import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { getBreakpoint } from './ui.service';
import { Observable } from 'rxjs';
import { Currency } from '../../components/currency-selector/currency-country-codes';
export type ViewportSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl' | 'xxxxl';

export interface UiState {
    landingPage: string;
    url?: string;
    viewportSize: ViewportSize;
    cssPropertySupport: boolean;
    currentCurrency?: Currency;
    currentTour?: string;
    scrollTopObservable?: Observable<number>;
    isMobile?: boolean;
}

export function createInitialState(): UiState {
    return {
        landingPage: '',
        viewportSize: getBreakpoint(window.innerWidth),
        cssPropertySupport: window && !!window.CSS?.['registerProperty'],
        isMobile: false
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ui', resettable: true })
export class UiStore extends Store<UiState> {
    constructor() {
        super(createInitialState());
    }
}
